import { forwardRef } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

import { COLORS, SCAN_STATUS } from '../../constants/scan-status';

const Legend = forwardRef(({ children, status, className, ...rest }, ref) => {

    const classes = useStyles();

    return (
        <Typography
            variant='caption'
            color='textSecondary'
            className={clsx(className, classes.root, classes[status])}
            {...rest}
            ref={ref}
        >
            {children}
        </Typography>
    )
})

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(0, 0.5),
        borderLeftWidth: 3,
        borderLeftStyle: 'solid',
        borderRadius: '0 4px 4px 0'
    },
    [SCAN_STATUS.ASSET_FOUND_BUT_MOVED]: {
        background: `${COLORS[SCAN_STATUS.ASSET_FOUND_BUT_MOVED]}11`,
        borderLeftColor: COLORS[SCAN_STATUS.ASSET_FOUND_BUT_MOVED]
    },
    [SCAN_STATUS.NEW_TAG]: {
        background: `${COLORS[SCAN_STATUS.NEW_TAG]}11`,
        borderLeftColor: COLORS[SCAN_STATUS.NEW_TAG]
    },
    [SCAN_STATUS.ASSET_FOUND]: {
        background: `${COLORS[SCAN_STATUS.ASSET_FOUND]}11`,
        borderLeftColor: COLORS[SCAN_STATUS.ASSET_FOUND]
    },
    [SCAN_STATUS.NOT_SCANNED]: {
        background: `${COLORS[SCAN_STATUS.NOT_SCANNED]}11`,
        borderLeftColor: COLORS[SCAN_STATUS.NOT_SCANNED]
    }
}))

export default Legend;